import React from "react";
import Joi from "joi-browser";
import Form from "../common/form";
import { getSingle, updateSingle } from "../../services/paidChequeService";
import { toast } from "react-toastify";
import BlockUi from "react-block-ui";
import TableTitle from "../common/tableTitle";
import { Table } from "semantic-ui-react";
import auth from "../../services/authService";
import { Link } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import queryString from "query-string";

class PaidChequeEditForm extends Form {
  state = {
    invoiceDate: new Date(),
    imageUrl: false,
    data: {
      client: "",
      mobile_no: "",
      description: "",
      amount: "",
    },
    attachment: "",
    errors: {},
  };

  schema = {
    client: Joi.string().required().label("Client"),
    mobile_no: Joi.string().required().label("Mobile"),
    description: Joi.string().required().label("Description"),
    amount: Joi.number().required().label("Amount"),
  };

  async populateAccount() {
    try {
      const accountId = this.props.match.params.id;
      this.setState({ blocking: true });
      const { data: account } = await getSingle(accountId);

      this.setState({ blocking: false });
      this.setState({ data: this.mapToViewModel(account) });

      const dateData = this.mapingData(account);

      console.log(dateData);

      this.setState({
        invoiceDate: new Date(dateData.invoiceDate),
        attachment: account.attachment,
      });
    } catch (ex) {
      if (ex.response && ex.response.status === 404)
        this.props.history.replace("/not-found");
    }
  }

  mapingData(account) {
    return {
      invoiceDate: account.date,
    };
  }

  async componentDidMount() {
    await this.populateAccount();
  }

  onChangeFile = (e) => {
    let files = e.target.files || e.dataTransfer.files;
    if (!files.length) return;
    this.setState({ imageUrl: files[0] });
    //this.createImage(files[0]);
  };

  mapToViewModel(account) {
    return {
      client: account.client,
      mobile_no: account.mobile_no,
      description: account.description,
      amount: account.amount,
    };
  }

  handleChangeInvoice = (date) => {
    this.setState({
      invoiceDate: date,
    });
  };

  doSubmit = async () => {
    try {
      const ledgerTypeId = this.props.match.params.id;

      let formData = new FormData();
      formData.append("client", this.state.data.client);
      formData.append("mobile_no", this.state.data.mobile_no);
      formData.append("description", this.state.data.description);
      formData.append("amount", this.state.data.amount);
      formData.append("attachment", this.state.imageUrl);
      formData.append("_method", "PUT");

      let event = new Date(this.state.invoiceDate);
      let date = JSON.stringify(event);
      date = date.slice(1, 11);

      formData.append("date", date);

      await updateSingle(formData, ledgerTypeId);

      this.setState({ blocking: false });
      toast.success("Entry has been updated successfully.");
      this.props.history.push("/pdc-cheques/paid");
    } catch (ex) {
      console.log(ex.response);
      if (ex.response && ex.response.status === 422) {
        const errors = { ...this.state.errors };

        if (ex.response.data.errors.passport_number)
          errors.passport_number = ex.response.data.errors.passport_number;

        if (ex.response.data.errors.identification_id)
          errors.identification_id = ex.response.data.errors.identification_id;

        if (ex.response.data.errors.mobile)
          errors.mobile = ex.response.data.errors.mobile;

        if (ex.response.data.errors.name)
          errors.name = ex.response.data.errors.name;

        this.setState({ errors, blocking: false });
        // toast.warning("check validation errors.");
      }
    }
  };

  render() {
    const { keyword, status } = queryString.parse(this.props.location.search);

    // if (auth.getCurrentUser().email != "client-unblocker@gondalgroup.ae") {
    //   return "Your are authorized to perform this action.";
    // }

    return (
      <BlockUi tag="div" blocking={this.state.blocking}>
        <h1 className="container__heading">Update Entry</h1>

        <Link
          to={`/pdc-cheques/paid?keyword=${keyword}&status=${status}`}
          className="btn btn--secondary"
          style={{ marginBottom: "1rem", display: "inline-block" }}
        >
          Back
        </Link>
        <form onSubmit={this.handleSubmit}>
          <div className="card form">
            <div className="form__content">
              <h3 className="card__heading">Update Entry</h3>
              <p>Provide the information below to update the entry.</p>
              <label>Date</label>
              <DatePicker
                selected={this.state.invoiceDate}
                onChange={this.handleChangeInvoice}
                className="input"
              />
              {this.renderInput("client", "Client", "text")}
              {this.renderInput("mobile_no", "Mobile", "text")}
              {this.renderInput("description", "Description", "text")}
              {this.renderInput("amount", "Amount", "text")}
              <div>
                <label>Attachment</label>
                <input
                  className="input"
                  type="file"
                  onChange={this.onChangeFile}
                />
                {this.state.attachment != "" ? (
                  <a
                    target="_blank"
                    href={
                      process.env.REACT_APP_BACKEND_URL +
                      "/storage/" +
                      this.state.attachment
                    }
                  >
                    Download
                  </a>
                ) : (
                  ""
                )}
              </div>

              {this.renderButton("Update")}
            </div>
          </div>
        </form>
      </BlockUi>
    );
  }
}

export default PaidChequeEditForm;
